module.exports = __webpack_public_path__ + "media/09-amph-serotonin.7bdb54b2.mp4";